import { AssignmentNodeData } from "src/constants/NodeDataTypes";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";

export const extractAssignmentNodeFields = (
  data: AssignmentNodeData,
): SearchableField[] => {
  const searchableEffects = data.default_effects.flatMap(
    ({ id, target, value }) => [
      {
        id: `${id}:target`,
        value: `data.${target}`,
      },
      {
        id: `${id}:value`,
        value: value,
      },
    ],
  );

  return searchableEffects;
};
